/* eslint-disable jsx-a11y/anchor-is-valid */
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableLoading} from '../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {getLaundryBatch} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {ColumnTable} from './columns'
import {FormLaundryBatch} from './form'
import {TabLavanderiaModel} from '../../../../../../models'

const TableLaundryBatch: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
  } = useKTable()
  const {columns} = ColumnTable()
  const {isAllowed, changeCurrentTabItem, currentTabItem} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [formValues, setFormValues] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<boolean>(false)
  const getLaundryList = async () => {
    setLoading(true)
    let obj = {...searchValues, ...formValues}
    const response = await getLaundryBatch(obj, pagination.currentPage)
    const dataInfo = response.data?.data || []
    if (!response.data.error) {
      setData(dataInfo)
      setPagination({
        ...pagination,
        totalResults: response.data.total,
      })
    }
    setData(dataInfo)
    setLoading(false)
  }

  useEffect(() => {
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (pagination.currentPage > 1) {
      getLaundryList()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getLaundryList()
      const obj: TabLavanderiaModel = {
        ...currentTabItem,
        typeWash: formValues.tipoLavado,
      }
      changeCurrentTabItem(obj)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getLaundryList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      setData([])
      setClearTable(false)
    }
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <KTCard shadow className='w-100'>
      <FormLaundryBatch
        getLaundryList={getLaundryList}
        formValues={formValues}
        setFormValues={setFormValues}
        formValueLoading={formValueLoading}
        setFormValueLoading={setFormValueLoading}
      />
      {isAllowed('LISTAR') && (
        <>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </>
      )}
    </KTCard>
  )
}

export {TableLaundryBatch}
